import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, Text, DaLabel } from '@paygreen/paygreen-ui';
import SkeletonTextLine from './SkeletonTextLine';
import { IsMobile } from '../../utils/tools';

const LineKeyValue = ({
    t,
    isLoading,
    keyLabel,
    keyValue,
    children,
    textSize,
    paddingLeft,
    defaultValue,
}) => (
    <>
        <SkeletonTextLine
            blockWidth="xl"
            colorWab="grey10"
            isLoading={isLoading}
        >
            <DaLabel>
                <Text
                    textSize={textSize}
                    colorWab="grey30"
                    marginTop={IsMobile() ? 'xs' : 'none'}
                >
                    {keyLabel}
                </Text>
            </DaLabel>
        </SkeletonTextLine>

        <Box paddingLeft={paddingLeft}>
            <SkeletonTextLine
                colorWab="grey10"
                isLoading={isLoading}
                blockWidth="auto"
            >
                {keyValue && children ? (
                    children
                ) : (
                    <Text
                        textSize={textSize}
                        htmlTag={!keyValue ? 'em' : null}
                        colorWab={!keyValue ? 'grey40' : 'grey60'}
                        style={{ wordBreak: 'break-all' }} // to break word in case of very long fingerprint specially on mobile
                    >
                        {keyValue
                            ? keyValue
                            : defaultValue || t('user.create.noDataFound')}
                    </Text>
                )}
            </SkeletonTextLine>
        </Box>
    </>
);

LineKeyValue.propTypes = {
    keyLabel: PropTypes.string.isRequired,
    keyValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isLoading: PropTypes.bool,
    textSize: PropTypes.string,
    paddingLeft: PropTypes.string,
    defaultValue: PropTypes.string,
};

LineKeyValue.defaultProps = {
    isLoading: false,
    textSize: 'xxs',
    paddingLeft: 'none',
};

export default withTranslation('common')(LineKeyValue);
